const shadows = {
  /** The  */
  smallest: '0.4px 2px 3px rgba(0, 0, 0, 0.16)',
  medium: '1px 5px 10px rgba(0, 0, 0, 0.1)',
  raised: '0.4px 2px 4px rgba(0, 0, 0, 0.02)', // TODO
  floating: '1px 5px 10px rgba(0, 0, 0, 0.04)', // Used for SiteSearch
  overlay: '3px 15px 20px rgba(0, 0, 0, 0.1)', // Used for SiteSearch
  dialog: '4px 20px 40px rgba(0, 0, 0, 0.2)', // TODO
};

export default shadows;
